<div class="modal-header">
  <label><strong>Fundraising Tools</strong></label>
</div>
<div class="modal-body">
  <div class="form-group mb-0 pb-2">
      <ul class="name-value" style="width: 100%;">
        <li>
          <label for="artifactId">Artifact Id:</label>
          <span id="artifactId">{{fundraisingToolsApp?.artifactId}}</span>
        </li>
        <li>
          <label for="artifactVersion">Artifact Version:</label>
          <span id="artifactVersion">{{fundraisingToolsApp?.artifactVersion}}</span>
        </li>
        <li>
          <label for="branchName">Branch Name:</label>
          <span id="branchName">{{fundraisingToolsApp?.branchName}}</span>
        </li>
        <li>
          <label for="buildNumber">Build Number:</label>
          <span id="buildNumber">{{fundraisingToolsApp?.buildNumber}}</span>
        </li>
        <li>
          <label for="uiBranchName">UI Branch Name:</label>
          <span id="uiBranchName">{{uiBuildNumber}}</span>
        </li>
      </ul>
  </div>
</div>
<div class="modal-header">
  <label><strong>Logical API</strong></label>
</div>
<div class="modal-body">
  <div class="form-group mb-0 pb-2">
    <ul class="name-value" style="width: 100%;">
      <li>
        <label for="logicalApiArtifactId">Artifact Id:</label>
        <span id="logicalApiArtifactId">{{logicalApiApp?.artifactId}}</span>
      </li>
      <li>
        <label for="logicalApiArtifactVersion">Artifact Version:</label>
        <span id="logicalApiArtifactVersion">{{logicalApiApp?.artifactVersion}}</span>
      </li>
      <li>
        <label for="logicalApiBranchName">Branch Name:</label>
        <span id="logicalApiBranchName">{{logicalApiApp?.branchName}}</span>
      </li>
      <li>
        <label for="logicalApiBuildNumber">Build Number:</label>
        <span id="logicalApiBuildNumber">{{logicalApiApp?.buildNumber}}</span>
      </li>
    </ul>
  </div>
  <div class="modal-header">
    <label><strong>Environment</strong></label>
  </div>
  <div class="modal-body">
    <div class="form-group mb-0 pb-2">
      <ul class="name-value" style="width: 100%;">
        <li>
          <label for="environmentApiUrl">apiUrl:</label>
          <span id="environmentApiUrl" style="word-wrap:break-word;">{{environmentConfig?.apiUrl}}</span>
        </li>
        <li>
          <label for="environmentFundraiseUrl">fundraiseUrl:</label>
          <span id="environmentFundraiseUrl" style="word-wrap:break-word;">{{environmentConfig?.fundraiseUrl}}</span>
        </li>
        <li>
          <label for="environmentGraphqlUrl">graphqlUrl:</label>
          <span id="environmentGraphqlUrl" style="word-wrap:break-word;">{{environmentConfig?.graphqlUrl}}</span>
        </li>
        <li>
          <label for="environmentGraphqlUrl">pagesUrl:</label>
          <span id="environmentPagesUrl" style="word-wrap:break-word;">{{environmentConfig?.pagesUrl}}</span>
        </li>
        <li>
          <label for="environmentWebServicesUrl">webServicesUrl:</label>
          <span id="environmentWebServicesUrl" style="word-wrap:break-word;">{{environmentConfig?.webServicesUrl}}</span>
        </li>
        <li>
          <label for="environmentFacebookAppId">facebookAppId:</label>
          <span id="environmentFacebookAppId" style="word-wrap:break-word;">{{environmentConfig?.facebookAppId}}</span>
        </li>
        <li>
          <label for="environmentFacebookkGraphApiVersion">facebookGraphApiVersion:</label>
          <span id="environmentFacebookGraphApiVersion" style="word-wrap:break-word;">{{environmentConfig?.facebookGraphApiVersion}}</span>
        </li>
        <li>
          <label for="environmentGoogleAppId">googleAppId:</label>
          <span id="environmentGoogleAppId" style="word-wrap:break-word;">{{environmentConfig?.googleAppId}}</span>
        </li>
        <!-- li>
          <label for="logicalApiHost">Host</label>
          <span id="logicalApiHost">{{logicalApiApp?.host}}</span>
        </li -->
      </ul>
    </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="activeModal.close('Close click')">Close</button>
</div>
